import { AuthService } from './../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { StoreService } from './../../services/store.service';
import { ApiService } from './../../services/api.service';
import { Profil } from './../../models/Profil';
import { CommandeService } from './../../services/commande.service';
import { SelectItem, Message, ConfirmationService, UIChart } from 'primeng/primeng';
import { CommandeBordereau } from 'src/app/models/CommandeBordereau';
import { CommandeDetail } from 'src/app/models/CommandeDetail';
import { Commande } from 'src/app/models/Commande';
import { ThrowStmt } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { LocaliteService } from 'src/app/services/reporting/localites.service';
import { ClientsService } from 'src/app/services/reporting/clients.service';
import { ReportingVenteService } from 'src/app/services/reporting/reporting.vente.service';
import { CriteriaData } from 'src/app/models/CriteriaData';

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.css']
})
export class AccueilComponent implements OnInit {

  titre = 'Accueil';
  msgs: Message[] = [];

  dataLine: any;
  dataBar: any;
  dataPie: any;
  currentUser: any;


  listMsisdn: SelectItem[] = [];
  listLogin: SelectItem[] = [];
  selectedPdg: string;
  selectedMsisdn: string;
  datedebut: any = new Date();
  datefin: any = new Date();

  items: any[] = [];

  margeArriereTelco:number=0;
  margeAvantTelco:number=0;
  commissionCashin:number=0;
  commissionCashout:number=0;
  montantCommande:number=0;
  montantVente:number=0;
  totalCommissionOmy:number=0;
  totalCommissionTelco:number=0;
  montantOmy:number=0;

  selectedAnnee: any ;
  selectedMois: any ;
  listAnnee: SelectItem[] = [];
  listMois: SelectItem[] = [];
  displaychargement:boolean;

  itemNumerosPdg : any[] = [];
  itemCommandesPdg : any[] = [];

  droitCommission: boolean;

  hasDroitCommandeNafama: boolean;
  hasDroitMesVentes: boolean;
  hasDroitCommission: boolean;
  hasDroitMarges: boolean;
  hasDroitCashInCashOut: boolean;
  hasDroitCoPvRegion: boolean;

  constructor(
    private confirmationService: ConfirmationService,
    public authService: AuthService,
    private commandeService: CommandeService,
    private datePipe: DatePipe,
    private localiteService: LocaliteService,
    private clientsService: ClientsService,
    private reportingVenteService: ReportingVenteService,
    private store: StoreService) { }

  async ngOnInit() {

    this.hasDroitCommandeNafama = await  this.authService.hasDroit('MENU_001');
    this.hasDroitMesVentes = await  this.authService.hasDroit('MENU_009');
    this.hasDroitCommission = await  this.authService.hasDroit('MENU_010');
    this.hasDroitMarges = await  this.authService.hasDroit('MENU_011');
    this.hasDroitCashInCashOut = await  this.authService.hasDroit('MENU_012');
    this.hasDroitCoPvRegion = await  this.authService.hasDroit('MENU_013');

    //this.currentUser = this.store.currentLogin;
    console.log('user: currentLogin ', this.store.currentLogin);
    console.log('user: currentNomPDG ', this.store.currentNomPDG);
    this.loadSelectList();
    this.recherche(this.store.currentNomPDG);


//this.droitCommission = this.authService.currentUser.profil.listDroit;
    //REP_001

    //this.initChartLine();
    //this.initChartBarre();
    //this.reloadPage();
  }

  reloadPage(){
    console.log('in reloadPage');
    if(sessionStorage.getItem("SESSION_RELAD_FIRST") === 'OK' ) {
      location.reload();
      console.log('in reloadPage 2');
      sessionStorage.removeItem("SESSION_RELAD_FIRST");
    }
    
  }


  async recherche(selectedPdg) {

    this.margeArriereTelco=0;
    this.margeAvantTelco=0;
    this.commissionCashin=0;
    this.commissionCashout=0;
    this.montantCommande=0;
    this.montantVente=0;
    this.totalCommissionOmy=0;
    this.totalCommissionTelco=0;
    this.montantOmy=0;
    this.items = [];
    this.itemNumerosPdg = [];
    this.itemCommandesPdg = [];

    if(selectedPdg === null || selectedPdg === undefined || selectedPdg === '') {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un login ' });
      return;
    }

    if(this.selectedAnnee === null || this.selectedAnnee === undefined || this.selectedAnnee === '') {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection une année' });
      return;
    }
    if(this.selectedMois === null || this.selectedMois === undefined || this.selectedMois === '') {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un mois ' });
      return;
    }

    let criteria: CriteriaData = new CriteriaData();
    criteria.pdg = selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.datedebut = "01/"+this.selectedMois+"/"+this.selectedAnnee ; //this.localeDateString(this.datedebut);
    criteria.datefin = "31/"+this.selectedMois+"/"+this.selectedAnnee ; //this.localeDateString(this.datefin);
    criteria.annee = this.selectedAnnee;
    criteria.mois = this.selectedMois;
    console.log("criteria================================ " + JSON.stringify(criteria));

    this.displaychargement=true;
    try {
      this.items = <any>await this.reportingVenteService.commissions(criteria).toPromise();
      console.log('items======'+ JSON.stringify(this.items));
    } catch (error) {
      this.items = [];
    }

    try {
      this.itemNumerosPdg = <any>await this.clientsService.searchMsisdn(selectedPdg).toPromise();
      console.log('itemNumerosPdg======'+ JSON.stringify(this.itemNumerosPdg));
    } catch (error) {
      this.itemNumerosPdg = [];
    }

    try {
      this.itemCommandesPdg = <any>await this.clientsService.searchLastCommandes(selectedPdg).toPromise();
      console.log('itemCommandesPdg======'+ JSON.stringify(this.itemCommandesPdg));
    } catch (error) {
      this.itemCommandesPdg = [];
    }
    
    this.displaychargement=false;

    ////// FAIRE LES TOTAUX ET CHART /////
    this.margeArriereTelco=0;
    this.margeAvantTelco=0;
    this.commissionCashin=0;
    this.commissionCashout=0;
    this.montantCommande=0;
    this.montantVente=0;
    this.totalCommissionOmy=0;
    this.totalCommissionTelco=0;
    this.montantOmy=0;

    this.items.forEach(e => {
      this.montantCommande += Number(e.montant_commande_nafama) + Number(e.montant_commande_cag);
      this.montantVente += Number(e.ca_nafama) + Number(e.ca_cag);
      this.margeAvantTelco += Number(e.marge_avant_cag) + Number(e.marge_avant_nafama)  ;
      this.margeArriereTelco += Number(e.commission_sell_in_cag) + Number(e.commission_sell_out_cag) + Number(e.commission_sell_in_nafama) + Number(e.commission_sell_out_nafama) ;
      this.commissionCashout += Number(e.cashout_commission_pdg);
      this.commissionCashin += Number(e.cashin_commission_pdg);
    });
    this.totalCommissionTelco = this.margeAvantTelco + this.margeArriereTelco;
    this.totalCommissionOmy = this.commissionCashout + this.commissionCashin;
    
    
    //this.printChartDonut(chartDonut);
    //this.printChartPie(chartPie);
  }


  async loadSelectList() {

    if(this.store.isUserPartenaire) {
      this.listLogin.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
      this.selectedPdg = this.store.currentNomPDG;
    } else {
      this.listLogin.push({ label: 'Selectionner...', value: null });
      try {
        let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
        for (let el of dataRetourPdg) {
          this.listLogin.push({ label: el.login + " - " + el.msisdn, value: el.login });
        }
      } catch (error) { }
    }

    this.listMsisdn = [];
    this.listMsisdn.push({ label: 'Msisdn...', value: null });

    this.listMois = [];
    //this.listMois.push({ label: 'Mois...', value: null });
    this.listMois.push({ label: 'Janvier', value: "01" });
    this.listMois.push({ label: 'Février', value: "02" });
    this.listMois.push({ label: 'Mars', value: "03" });
    this.listMois.push({ label: 'Avril', value: "04" });
    this.listMois.push({ label: 'Mai', value: "05" });
    this.listMois.push({ label: 'Juin', value: "06" });
    this.listMois.push({ label: 'Juillet', value: "07" });
    this.listMois.push({ label: 'Aout', value: "08" });
    this.listMois.push({ label: 'Septembre', value: "09" });
    this.listMois.push({ label: 'Octobre', value: "10" });
    this.listMois.push({ label: 'Novembre', value: "11" });
    this.listMois.push({ label: 'Decembre', value: "12" });
    this.listAnnee = [];
    //this.listAnnee.push({ label: 'Année...', value: null });
    this.listAnnee.push({ label: '2022', value: "2022" });
    this.listAnnee.push({ label: '2023', value: "2023" });
    this.listAnnee.push({ label: '2024', value: "2024" });
    this.listAnnee.push({ label: '2025', value: "2025" });
    this.listAnnee.push({ label: '2026', value: "2026" });
    this.listAnnee.push({ label: '2027', value: "2027" });
    this.listAnnee.push({ label: '2028', value: "2028" });
    this.listAnnee.push({ label: '2029', value: "2029" });
    this.listAnnee.push({ label: '2030', value: "2030" });
    
    let mydate = new Date();
    this.selectedAnnee = mydate.getFullYear() ;
    let mmois = mydate.getMonth() + 1;
    this.selectedMois =  (mmois > 9) ? mmois : "0"+mmois ; 
    console.log("this.selectedAnnee===="+this.selectedAnnee); 
    console.log("this.selectedMois===="+this.selectedMois);    

  }

  async onChangePDG(event) {
    this.recherche(event);
  }


  localeDateString(val: any): any {
    if (val === null || val === undefined) {
      return null;
    }
    if (typeof val === 'string') {
      return val;
    } else {
      return this.datePipe.transform(val, "dd/MM/yyyy");
    }
  }


  initChartLine() {
    this.dataLine = {
      labels: ['NAFAMA', 'ORANGE MONEY', 'CARTE RECHARGE', 'CARTE SIM', 'TERMINEAUX'],
      datasets: [
          {
              label: 'Septembre',
              data: [65, 59, 80, 81, 56],
              fill: false,
              borderColor: '#4bc0c0'
          },
          {
              label: 'Aout',
              data: [28, 48, 40, 19, 86],
              fill: false,
              borderColor: '#565656'
          }
      ]
    };
  }

  initChartBarre() {
    this.dataBar = {
      labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
      datasets: [
          {
              label: 'Mois Passé',
              backgroundColor: '#ff7e33',
              borderColor: '#ff7e33',
              data: [650000, 590000, 800000, 810000, 560000, 550000, 280000, 480000, 400000, 190000, 860000, 270000]
          },
          {
            label: 'Mois encours',
            backgroundColor: '#42A5F5',
            borderColor: '#42A5F5',
            data: [600000, 630000, 700000, 800000, 460000, 450000, 380000, 580000, 300000, 300000, 960000, 200000]
        }
      ]
    };
  }

}
